// extracted by mini-css-extract-plugin
export default {"icons-list":"listOfIcons_icons-list__7wjLJ","icon":"listOfIcons_icon__ImESb"};